/**
 * Prefer tip `editedBody` over the machine artifact body for study-doc reads.
 * Gate `outputOverride` is intentionally out of scope.
 */
export function reconcileArtifactBody(
  machineBody: string,
  tip: { editedBody: string } | null | undefined,
): string {
  if (tip && typeof tip.editedBody === 'string') {
    return tip.editedBody
  }
  return machineBody
}
